// extracted by mini-css-extract-plugin
export default {"add_button_anchor":"ScriptComponent_add_button_anchor__wuMpR","add_button":"ScriptComponent_add_button__BST-5"};